import { Component, OnInit } from '@angular/core';
import { Paymentterm } from '../paymentterm';
import { PaymenttermService } from '../paymentterm.service';
import { VendorService } from '../../vendor/vendor.service';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-add-paymentterm',
  templateUrl: './add-paymentterm.component.html',
  styleUrls: ['./add-paymentterm.component.css']
})
export class AddPaymenttermComponent implements OnInit {

  paymentterm = new Paymentterm();
  paymenttermdata : any = {}
  submitted = false;
	vendors: any[];
  paymentterms: any [];
    requester: any [];
  
    private newAttribute: any = {};
    paymenttermForm: FormGroup;
    public isupdate = false;
    public FormName = "Add New Payment Terms";

  constructor(
    private paymenttermService: PaymenttermService, 
    private vendorService : VendorService,
    private location: Location, 
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    public toastr: ToastrManager, 
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
    ) { }

    newPo(): void {
      this.submitted = false;
      this.paymentterm = new Paymentterm();
    }

    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.paymenttermForm.invalid) {
          return this.util.showError("Please enter required fields.");		
      }
    else{
      if(this.isupdate){
        this.update();
      }
      else{
        this.addPaymentterm();
      }
    }
  }

  addPaymentterm() {
      //this.submitted = true;
      this.save();
    }
	
   
  private save(): void {	  
   
  
   this.paymentterm.createdby = this.auth.currentUserValue.userid
   
	  this.paymenttermService.addPaymentterm(this.paymentterm).subscribe((data :any) => {
		  console.log(data);
		  this.util.showSuccess("Payment Term added successfully.")
		});
		this.router.navigate(['/paymentterm-list']);
          //for Redirecting to the list view     
  }
  goBack(): void {
    this.location.back();
  }

  update(): void {
    this.submitted = true;
 
    this.paymenttermService.updatePaymentterm(this.paymentterm)
        .subscribe(() => this.util.showSuccess("Payment Term update successfully."));
        this.router.navigate(['/paymentterm-list']);
  }
  
  ngOnInit() {
	
    this.paymentterm.active = 1;
    if(this.route.snapshot.paramMap.get('paymenttermid') != null)
    {
      const paymenttermid = +this.route.snapshot.paramMap.get('paymenttermid');
       if(paymenttermid > 0)
       {
         this.getPaymentterm(paymenttermid);
       }
       this.isupdate = true;
       this.FormName = "Update Payment Term";				 
    }
    this.paymenttermForm = this.formBuilder.group({			
      paymentterms: [this.paymentterm.paymentterms,[Validators.required, Validators.required]],
     noofday: [this.paymentterm.noofday,[Validators.required, Validators.required]],
     active: [this.paymentterm.active,[Validators.required, Validators.required]]
    });	
  
  }
  // convenience getter for easy access to form fields
get f() {
  return this.paymenttermForm.controls
  }
 
 

getPaymentterm(paymenttermid) {
  return this.paymenttermService.getPaymentterm(paymenttermid)
             .subscribe(
              paymentterm => {              
                this.paymentterm = paymentterm              
               }
              );
}

//below function is to restrict special character in input field
omit_special_char(e) {
  var k;
  document.all ? k = e.keyCode : k = e.which;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

}
